import e from"./Hits.vue_vue&type=script&lang.js";import{render as t}from"./Hits.vue_vue&type=template&id=ef242920&lang.js";e.render=t,e.__file="src/components/Hits.vue";export default e;
//# sourceMappingURL=Hits.vue.js.map
